import type { TFunction } from 'i18next';

import type { WorkflowDefinition } from './workflows-api';

/* ---------------------------------------------------------------------------
   תבניות מוכנות — נקודת התחלה בבונה (נפתחות לעריכה, לא נשמרות לבד).
   המשתנים ({{customer.name}}) הם של השרת (workflow-dsl.ts), לא של i18next —
   לכן הם מחוברים כאן בקוד ולא יושבים בקובץ התרגום.
   --------------------------------------------------------------------------- */

export interface WorkflowTemplate {
  key: 'kitchenMeasure' | 'satisfaction' | 'bigQuote';
  def: WorkflowDefinition;
}

export function workflowTemplates(
  t: TFunction<'workflows'>,
  lookups: { firstJobTypeId?: string; firstFieldUserId?: string },
): WorkflowTemplate[] {
  return [
    {
      key: 'kitchenMeasure',
      def: {
        name: t('templates.kitchenMeasure.name'),
        trigger: { type: 'event', event: 'quote.approved', delayDays: 0 },
        conditions: lookups.firstJobTypeId
          ? [{ type: 'job_type', op: 'in', jobTypeIds: [lookups.firstJobTypeId] }]
          : [],
        actions: [
          {
            type: 'create_task',
            title: `${t('templates.kitchenMeasure.title')} — {{customer.name}}`,
            dueInDays: 2,
            assign: lookups.firstFieldUserId
              ? { mode: 'user', userId: lookups.firstFieldUserId }
              : { mode: 'auto' },
          },
        ],
      },
    },
    {
      key: 'satisfaction',
      def: {
        name: t('templates.satisfaction.name'),
        trigger: { type: 'event', event: 'task.closed', delayDays: 3 },
        conditions: [],
        actions: [{ type: 'send_customer_message', template: 'satisfaction' }],
      },
    },
    {
      key: 'bigQuote',
      def: {
        name: t('templates.bigQuote.name'),
        trigger: { type: 'event', event: 'quote.approved', delayDays: 0 },
        conditions: [{ type: 'amount', op: 'gte', value: 10_000 }],
        actions: [
          {
            type: 'notify_team',
            message: `${t('templates.bigQuote.message')}: #{{quote.number}} · {{customer.name}} · {{quote.total}}`,
            includeOwners: true,
            userIds: [],
            email: false,
          },
        ],
      },
    },
  ];
}
